import { Observable } from 'rxjs';
import { InitMenutType } from '@shared/component.header';
import { Router } from '@angular/router';

export abstract class HeaderRepository {
  abstract getMenuheader(isEnglish: boolean): Observable<InitMenutType>;
  abstract getLogoPaths(router: Router): Observable<{ logoUrl: string }>;
}
